// Narrowing without assertions: anything read from storage, the network or a
// message is `unknown` until a guard says what it is, so no code in the learn
// feature needs `as` to look inside it.
export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}
